<template>
	<div class="quotation_deadline pa-2">
		<section class="order-received-area" v-if="contract || contract == 'nil'">
			<label class="text-body-2 font-weight-bold">見積り</label>
			<v-menu close-on-content-click transition="scale-transition" offset-y min-width="auto">
				<template v-slot:activator="{ on, attrs }">
					<v-text-field
						class="mt-4"
						v-model="quotation.quotationDeadline"
						label="見積納期(見込納期)"
						required
						readonly
						outlined
						dense
						v-bind="attrs"
						v-on="on"
					/>
				</template>
				<v-date-picker v-model="quotation.quotationDeadline" no-title locale="ja-JP" />
			</v-menu>

			<v-menu close-on-content-click transition="scale-transition" offset-y min-width="auto">
				<template v-slot:activator="{ on, attrs }">
					<v-text-field
						class="mt-4"
						v-model="quotation.quotationSubmissionDate"
						label="見積提出日"
						required
						readonly
						outlined
						dense
						v-bind="attrs"
						v-on="on"
					/>
				</template>
				<v-date-picker v-model="quotation.quotationSubmissionDate" no-title locale="ja-JP" />
			</v-menu>

			<label class="text-body-2 font-weight-bold">受注</label>

			<v-menu close-on-content-click transition="scale-transition" offset-y min-width="auto">
				<template v-slot:activator="{ on, attrs }">
					<v-text-field
						class="mt-4"
						v-if="contract && contract !== 'nil'"
						v-model="quotation.deadline"
						label="実納期（受注時）"
						required
						readonly
						outlined
						dense
						v-bind="attrs"
						v-on="on"
					/>
				</template>
				<v-date-picker v-if="contract && contract !== 'nil'" v-model="quotation.deadline" no-title locale="ja-JP" />
			</v-menu>

			<v-menu close-on-content-click transition="scale-transition" offset-y min-width="auto">
				<template v-slot:activator="{ on, attrs }">
					<v-text-field
						class="mt-4"
						v-model="quotation.plannedOrderDate"
						label="受注見込日"
						required
						readonly
						outlined
						dense
						v-bind="attrs"
						v-on="on"
					/>
				</template>
				<v-date-picker v-model="quotation.plannedOrderDate" no-title locale="ja-JP" />
			</v-menu>

			<v-select
				v-model="quotation.companyPeriod"
				label="受注/失注　決算期"
				class="mt-4"
				outlined
				required
				dense
				:items="company_periods"
				item-text="title"
				item-value="id"
			>
			</v-select>

			<v-menu close-on-content-click transition="scale-transition" offset-y min-width="auto">
				<template v-slot:activator="{ on, attrs }">
					<v-text-field
						class="mt-4"
						v-if="contract && contract !== 'nil'"
						v-model="quotation.orderDate"
						label="受注日"
						required
						readonly
						outlined
						dense
						v-bind="attrs"
						v-on="on"
					/>
				</template>
				<v-date-picker v-model="quotation.orderDate" no-title locale="ja-JP" />
			</v-menu>

			<label class="text-body-2 font-weight-bold">原価</label>
			<v-menu close-on-content-click transition="scale-transition" offset-y min-width="auto">
				<template v-slot:activator="{ on, attrs }">
					<v-text-field
						class="mt-4"
						v-model="quotation.costingRequestDate"
						label="原価依頼計算日"
						required
						readonly
						outlined
						dense
						v-bind="attrs"
						v-on="on"
					/>
				</template>
				<v-date-picker v-model="quotation.costingRequestDate" no-title locale="ja-JP" />
			</v-menu>

			<v-menu close-on-content-click transition="scale-transition" offset-y min-width="auto">
				<template v-slot:activator="{ on, attrs }">
					<v-text-field
						class="mt-4"
						v-model="quotation.costReceiptDate"
						label="原価受領日"
						required
						readonly
						outlined
						dense
						v-bind="attrs"
						v-on="on"
					/>
				</template>
				<v-date-picker v-model="quotation.costReceiptDate" no-title locale="ja-JP" />
			</v-menu>
		</section>

		<section class="lost-orders-area" v-if="!contract || contract == 'nil'">
			<label class="text-body-2 font-weight-bold">見積り</label>
			<v-menu close-on-content-click transition="scale-transition" offset-y min-width="auto">
				<template v-slot:activator="{ on, attrs }">
					<v-text-field
						class="mt-4"
						v-model="quotation.quotationDeadline"
						label="見積納期(見込納期)"
						required
						readonly
						outlined
						dense
						v-bind="attrs"
						v-on="on"
					/>
				</template>
				<v-date-picker v-model="quotation.quotationDeadline" no-title locale="ja-JP" />
			</v-menu>

			<v-menu close-on-content-click transition="scale-transition" offset-y min-width="auto">
				<template v-slot:activator="{ on, attrs }">
					<v-text-field
						class="mt-4"
						v-model="quotation.quotationSubmissionDate"
						label="見積提出日"
						required
						readonly
						outlined
						dense
						v-bind="attrs"
						v-on="on"
					/>
				</template>
				<v-date-picker v-model="quotation.quotationSubmissionDate" no-title locale="ja-JP" />
			</v-menu>

			<label class="text-body-2 font-weight-bold">受注</label>

			<v-menu close-on-content-click transition="scale-transition" offset-y min-width="auto">
				<template v-slot:activator="{ on, attrs }">
					<v-text-field
						class="mt-4"
						v-model="quotation.plannedOrderDate"
						label="受注見込日"
						required
						readonly
						outlined
						dense
						v-bind="attrs"
						v-on="on"
					/>
				</template>
				<v-date-picker v-model="quotation.plannedOrderDate" no-title locale="ja-JP" />
			</v-menu>

			<v-select
				v-model="quotation.companyPeriod"
				label="受注/失注　決算期"
				class="mt-4"
				outlined
				required
				dense
				:items="company_periods"
				item-text="title"
				item-value="id"
			>
			</v-select>

			<label class="text-body-2 font-weight-bold">原価</label>
			<v-menu close-on-content-click transition="scale-transition" offset-y min-width="auto">
				<template v-slot:activator="{ on, attrs }">
					<v-text-field
						class="mt-4"
						v-model="quotation.costingRequestDate"
						label="原価依頼計算日"
						required
						readonly
						outlined
						dense
						v-bind="attrs"
						v-on="on"
					/>
				</template>
				<v-date-picker v-model="quotation.costingRequestDate" no-title locale="ja-JP" />
			</v-menu>

			<v-menu close-on-content-click transition="scale-transition" offset-y min-width="auto">
				<template v-slot:activator="{ on, attrs }">
					<v-text-field
						class="mt-4"
						v-model="quotation.costReceiptDate"
						label="原価受領日"
						required
						readonly
						outlined
						dense
						v-bind="attrs"
						v-on="on"
					/>
				</template>
				<v-date-picker v-model="quotation.costReceiptDate" no-title locale="ja-JP" />
			</v-menu>
		</section>

		<section class="unsettled-area" v-if="contract == 'nil'">
			<label class="text-body-2 font-weight-bold">見積り</label>
			<v-menu close-on-content-click transition="scale-transition" offset-y min-width="auto">
				<template v-slot:activator="{ on, attrs }">
					<v-text-field
						class="mt-4"
						v-model="quotation.quotationDeadline"
						label="見積納期(見込納期)"
						required
						readonly
						outlined
						dense
						v-bind="attrs"
						v-on="on"
					/>
				</template>
				<v-date-picker v-model="quotation.quotationDeadline" no-title locale="ja-JP" />
			</v-menu>
			<v-menu close-on-content-click transition="scale-transition" offset-y min-width="auto">
				<template v-slot:activator="{ on, attrs }">
					<v-text-field
						class="mt-4"
						v-model="quotation.quotationSubmissionDate"
						label="見積提出日"
						required
						readonly
						outlined
						dense
						v-bind="attrs"
						v-on="on"
					/>
				</template>
				<v-date-picker v-model="quotation.quotationSubmissionDate" no-title locale="ja-JP" />
			</v-menu>
			<label class="text-body-2 font-weight-bold">受注</label>
			<v-menu close-on-content-click transition="scale-transition" offset-y min-width="auto">
				<template v-slot:activator="{ on, attrs }">
					<v-text-field
						class="mt-4"
						v-model="quotation.plannedOrderDate"
						label="受注見込日"
						required
						readonly
						outlined
						dense
						v-bind="attrs"
						v-on="on"
					/>
				</template>
				<v-date-picker v-model="quotation.plannedOrderDate" no-title locale="ja-JP" />
			</v-menu>
			<v-select
				v-model="quotation.companyPeriod"
				label="受注/失注　決算期"
				class="mt-4"
				outlined
				required
				dense
				:items="company_periods"
				item-text="title"
				item-value="id"
			>
			</v-select>
			<label class="text-body-2 font-weight-bold">原価</label>
			<v-menu close-on-content-click transition="scale-transition" offset-y min-width="auto">
				<template v-slot:activator="{ on, attrs }">
					<v-text-field
						class="mt-4"
						v-model="quotation.costingRequestDate"
						label="原価依頼計算日"
						required
						readonly
						outlined
						dense
						v-bind="attrs"
						v-on="on"
					/>
				</template>
				<v-date-picker v-model="quotation.costingRequestDate" no-title locale="ja-JP" />
			</v-menu>

			<v-menu close-on-content-click transition="scale-transition" offset-y min-width="auto">
				<template v-slot:activator="{ on, attrs }">
					<v-text-field
						class="mt-4"
						v-model="quotation.costReceiptDate"
						label="原価受領日"
						required
						readonly
						outlined
						dense
						v-bind="attrs"
						v-on="on"
					/>
				</template>
				<v-date-picker v-model="quotation.costReceiptDate" no-title locale="ja-JP" />
			</v-menu>
		</section>
	</div>
</template>

<script>
export default {
	props: {
		quotation: {
			type: Object,
			required: false,
			default: () => {},
		},
		company_periods: {
			type: Array,
			required: false,
			default: () => [],
		},
		contract: {
			type: [String, Boolean],
		},
	},
	data() {
		return {}
	},
}
</script>
